import React, { FunctionComponent } from 'react'
import { Hero } from '@which/seatbelt'

import {
  SubVerticalCrTopicPageQuery,
  SubVerticalReviewsPageQuery,
} from '../../../../generated/frontend'
import styles from './SubVerticalHeader.module.scss'

export const SubVerticalHeader: FunctionComponent<Props> = ({ image, intro, title }) => (
  <div className={styles.subVerticalHeader} data-testid="sub-vertical-header">
    <Hero title={title} standfirst={intro} image={image} size={1} />
  </div>
)

///////// IMPLEMENTATION /////////

type Props =
  | SubVerticalCrTopicPageQuery['subVerticalPage']['header']
  | SubVerticalReviewsPageQuery['subVerticalPage']['header']
